import React from "react";
import "./shimmer.less";

const variants = {
  text: { width: "100%", height: 14, radius: 4 },
  title: { width: "200px", height: 18, radius: 4 },
  input: { width: "100%", height: 40, radius: 8 },
  button: { width: "120px", height: 40, radius: 8 },
  avatar: { width: 40, height: 40, radius: "50%" },
  card: { width: "100%", height: 120, radius: 10 },
};

const Shimmer = ({
  variant = "text",
  width,
  height,
  radius,
  margin = 0,
  marginTop,
  className = "",
  style = {},
  display = "block",
  circle = false,
  size = 40,
  loading = true,
}) => {
  if (!loading) return null;

  const preset = variants[variant] || variants.text;

  const finalWidth = circle ? size : (width ?? preset.width);
  const finalHeight = circle ? size : (height ?? preset.height);
  const finalRadius = circle ? "50%" : (radius ?? preset.radius);

  return (
    <div
      className={`shimmer-item ${className}`}
      style={{
        width: finalWidth,
        height: finalHeight,
        borderRadius: finalRadius,
        margin,
        ...(marginTop != null && { marginTop }),
        display,
        ...style,
      }}
      aria-busy="true"
      aria-label="Loading"
    />
  );
};

export default React.memo(Shimmer);